import type { FeeType } from "@dealer-center/core-feemanager-interface";

export const COMMON_ORG_TENANT_TYPE = "COMMON_ORG";

// Config values for NEW_feeSource / USED_feeSource; a missing value means DDC.
export const FEE_SOURCE_COMMON_ORG = "common_org";
export const FEE_SOURCE_DDC = "ddc";

export interface FeeSource {
  tenantType: string;
  tenantId: string;
}

export type FeeSources = Record<FeeType, FeeSource>;

export const isCommonOrgSource = (value: unknown): boolean =>
  typeof value === "string" && value.toLowerCase() === FEE_SOURCE_COMMON_ORG;

export const getFeeSourceValue = (
  config: Record<string, unknown>,
  type: FeeType
): string =>
  isCommonOrgSource(config[`${type}_feeSource`])
    ? FEE_SOURCE_COMMON_ORG
    : FEE_SOURCE_DDC;

// Where each vehicle type's fee bundle lives; null when a COMMON_ORG source has no corgi.
export const resolveFeeSources = (
  config: Record<string, unknown>,
  tenant: FeeSource,
  corgi: string | null
): FeeSources | null => {
  const resolve = (type: FeeType): FeeSource | null => {
    if (!isCommonOrgSource(config[`${type}_feeSource`])) return tenant;
    const trimmedCorgi = corgi?.trim();
    return trimmedCorgi
      ? { tenantType: COMMON_ORG_TENANT_TYPE, tenantId: trimmedCorgi }
      : null;
  };

  const newSource = resolve("NEW");
  const usedSource = resolve("USED");
  return newSource && usedSource ? { NEW: newSource, USED: usedSource } : null;
};

export const isSameFeeSource = (a: FeeSource, b: FeeSource): boolean =>
  a.tenantType === b.tenantType && a.tenantId === b.tenantId;
